import { memo, useEffect, useState } from "react";
import { clsx } from "clsx";

import { useViewFullscreen } from "../../hooks/useViewFullscreen";
import styles from "./ViewFullscreenHint.module.scss";

const HINT_VISIBLE_MS = 2200;

export const ViewFullscreenHint = memo(() => {
    const { isFullscreen } = useViewFullscreen();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!isFullscreen) {
            setIsVisible(false);
            return;
        }

        setIsVisible(true);
        const timeoutId = window.setTimeout(() => setIsVisible(false), HINT_VISIBLE_MS);

        return () => window.clearTimeout(timeoutId);
    }, [isFullscreen]);

    return (
        <div
            className={clsx(styles.hint, isVisible && styles.hintVisible)}
            role="status"
            aria-live="polite"
            aria-hidden={!isVisible}
        >
            <span className={styles.escKey}>Esc</span>
            <span>Нажмите, чтобы выйти из полноэкранного режима</span>
        </div>
    );
});
